module.exports = __webpack_public_path__ + "img/ielts-logo.d98fdfb0.png";